import { jsx as t, jsxs as e } from "react/jsx-runtime";
import { forwardRef as r } from "react";
import o from "../../assets/InfoIcon.svg.js";
import { useTheme as i } from "@mui/joy";
import l from "@mui/joy/Stack";
import n from "@mui/joy/Typography";
const m = r(({ error: r2, button: m2, icon: p, title: a, subtitle: s, sx: c }, f) => {
  const u = i(), y = t(o, { style: { fill: r2 ? u.palette.danger[500] : u.palette.isDarkMode ? u.palette.primary[700] : u.palette.primary[500] } });
  return e(l, { ref: f, sx: { justifyContent: "center", alignItems: "center", textAlign: "center", py: 2, gap: 1, ...c }, children: [p ?? y, t(n, { level: "title-md", textColor: "neutral.700", fontWeight: 600, children: a }), s ? t(n, { component: "div", level: "body-sm", textColor: "neutral.700", sx: { maxWidth: "450px" }, children: s }) : null, m2] });
});
export {
  m as InfoMessage
};
//# sourceMappingURL=InfoMessage.js.map
